import React, { useState } from "react";
import NewItemButton from "../../common/NewItemButton";
import SearchBar from "../../common/SearchBar";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchWithToken } from "../../../functions/fetch";
import TemplateMessageList from "./TemplateMessageList";
import { addSearchedField } from "../../../functions/templateMessage";
import ChakraPopUp from "../../common/PopUp/ChakraPopUp";
import {
  Flex,
  FormLabel,
  HStack,
  Textarea,
  useDisclosure,
} from "@chakra-ui/react";
import FormikInput from "../../common/PopUp/ChakraFormik/FormikInput";
import { useFormik } from "formik";
import { postTemplateMessageSchema } from "../../../validation/messageValidation";
import ErrorMessages from "../../common/PopUp/ChakraFormik/ErrorMessages";

const TemplateMessagePage = () => {
  // const [templateMessages, setTemplateMessages] = useState([]);
  const [filteredTemplateMessages, setFilteredTemplateMessages] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const queryClient = useQueryClient();

  const fetchTemplateMessages = async () => {
    const res = await fetchWithToken(
      "GET",
      `${process.env.REACT_APP_BACKEND_HOST}/api/template-message`,
    );
    // latest updated is in front
    const newTemplateMessages = res.templateMessages.sort(
      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
    );
    addSearchedField(newTemplateMessages);

    // setTemplateMessages(newTemplateMessages);
    setFilteredTemplateMessages(newTemplateMessages);

    return newTemplateMessages;
  };

  const { data: templateMessages } = useQuery({
    queryKey: ["templateMessages"],
    queryFn: fetchTemplateMessages,
    initialData: [],
  });

  const formik = useFormik({
    initialValues: {
      title: "",
      text: "",
    },
    onSubmit: async (values, { resetForm }) => {
      setIsSubmitting(true);
      const res = await fetchWithToken(
        "POST",
        `${process.env.REACT_APP_BACKEND_HOST}/api/template-message`,
        values,
      );
      if (res.status === 200) {
        resetForm();
        queryClient.invalidateQueries({ queryKey: ["templateMessages"] });
        setIsSubmitting(false);
        onClose();
      } else {
        console.error(res);
      }
    },
    validationSchema: postTemplateMessageSchema,
  });

  return (
    <>
      <ChakraPopUp
        isOpen={isOpen}
        onClose={onClose}
        isSubmitting={isSubmitting}
        onSubmit={formik.handleSubmit}
        title="新增公版訊息"
      >
        <Flex direction="column" gap={4}>
          <FormikInput formik={formik} field="title" labelText="公版標題" />
          <HStack>
            <FormLabel
              mb={0}
              whiteSpace="nowrap"
              alignSelf="start"
              htmlFor="text"
            >
              公版內容
            </FormLabel>
            <Textarea
              {...formik.getFieldProps("text")}
              variant="filled"
              id="text"
            />
          </HStack>
          <ErrorMessages formik={formik} />
        </Flex>
      </ChakraPopUp>
      <div className="flex justify-between items-center">
        <NewItemButton
          itemName="公版訊息"
          setShowPopUp={(value) => {
            if (value) {
              onOpen();
            } else {
              onClose();
            }
          }}
        />
        <SearchBar
          items={templateMessages}
          setFunction={setFilteredTemplateMessages}
        />
      </div>
      <TemplateMessageList templateMessages={filteredTemplateMessages} />
    </>
  );
};

export default TemplateMessagePage;
